import React, { useState, useEffect } from 'react';
import LazyImage from '../components/LazyImage';
import apiService from '../services/apiService';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import {
  AboutContainer,
  AboutHero,
  Container,
  PageTitle,
  PageSubtitle,
  AboutContent,
  AboutGrid,
  AboutText,
  AboutImage,
  MissionVisionSection,
  WhatSetsUsApartSection,
  LoadingSpinner
} from '../styles/AboutStyles';

const About = () => {
  const [aboutContent, setAboutContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        const about = await apiService.getAboutContent();
        setAboutContent(about);
      } catch (error) {
        console.error('Error fetching about content:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  if (loading) {
    return (
      <LoadingSpinner>
        <AiOutlineLoading3Quarters className="spinner" />
      </LoadingSpinner>
    );
  }

  if (!aboutContent) {
    return (
      <AboutContainer>
        <Container>
          <p>Unable to load about content. Please try again later.</p>
        </Container>
      </AboutContainer>
    );
  }

  // Values and stats sections have been removed as requested

  return (
    <AboutContainer>
      {/* Hero Section */}
      <AboutHero>
        <Container>
          <PageTitle>About Cocoa-Pro Corporation</PageTitle>
          <PageSubtitle>
            Leading the way in sustainable cocoa processing and agricultural excellence in Liberia
          </PageSubtitle>
        </Container>
      </AboutHero>

      {/* About Content */}
      <AboutContent>
        <Container>
          <AboutGrid>
            <AboutText className="about-text">
              <h2>Our Business Goal</h2>
              <p>{aboutContent.businessGoal}</p>
              <h2>Establishment and Growth</h2>
              <p>{aboutContent.establishmentAndGrowth}</p>
            </AboutText>
            {aboutContent.imageUrl && (
              <AboutImage className="about-image">
                <LazyImage
                  src={aboutContent.imageUrl}
                  alt="About Cocoa-Pro Corporation"
                  loadingHeight="400px"
                />
              </AboutImage>
            )}
          </AboutGrid>
        </Container>
      </AboutContent>

      {/* Mission & Vision Section */}
      <MissionVisionSection>
        <Container>
          <h2>Mission & Vision</h2>
          <p>
            <strong>Our Aim:</strong> {aboutContent.aim}
          </p>
          <p>
            <strong>Our Vision:</strong> {aboutContent.vision}
          </p>
        </Container>
      </MissionVisionSection>

      {/* What Sets Us Apart Section */}
      <WhatSetsUsApartSection>
        <Container>
          <h2>Liberia's Agricultural Landscape and CPC's Role</h2>
          <ul>
            {aboutContent.liberiasAgriculturalLandscapeAndCPCsRole.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
          
          <h2>Operations and Impact</h2>
          <ul>
            {aboutContent.operationsAndImpact.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
          
          <h2>Commitment to Liberia's Development</h2>
          <ul>
            {aboutContent.commitmentToLiberiasDevelopment.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
          
          <h2>Why Liberia?</h2>
          <ul>
            {aboutContent.whyLiberia.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </Container>
      </WhatSetsUsApartSection>

      {/* Values and Stats sections have been removed as requested */}
    </AboutContainer>
  );
};

export default About;
